module.exports = __webpack_public_path__ + "static/media/1.99027e64.png";